module.exports = __webpack_public_path__ + "img/USDC.3b5972c1.svg";